import api from '../../'

const questionTypes = () => {
  return api.get('administration/questionable_types').then(({ data }) => {
    return data
  })
}

export default questionTypes
